import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pwa-install-button',
  templateUrl: './pwa-install-button.component.html',
  styleUrls: ['./pwa-install-button.component.css']
})
export class PwaInstallButtonComponent implements OnInit {
  @Input() label: string = '';
  @Input() texto: string = '';
  @Input() btnClass: string = '';
  @Input() btnStyle: any = null;

  esIOS = false;
  esChromeIOS = false;
  esSafari = false;
  esAndroid = false;

  ngOnInit() {

    const ua =
      navigator.userAgent.toLowerCase();

    this.esIOS =
      /iphone|ipad|ipod/.test(ua) ||
      (
        navigator.platform === 'MacIntel' &&
        (navigator as any).maxTouchPoints > 1
      );

    this.esChromeIOS = this.esIOS && /crios/i.test(ua);

    this.esSafari =
      /^((?!chrome|android).)*safari/i
        .test(navigator.userAgent);

    this.esAndroid =
      /android/.test(ua);

  }

  instalar() {
    if (this.esIOS) {
      if (this.esChromeIOS) {
        alert(
          'Para crear el acceso directo siga los siguientes pasos:\n\n' +
          '1. Presione la opción de compartir ⬆ en la parte del enlace\n' +
          '2. Presione "Ver más"\n' +
          '3. Seleccione "Añadir a pantalla de inicio"\n' +
          '4. Desmarca la opción "Abrir como app web"\n' +
          '5. Presione en Añadir'
        );
        return;
      }

      alert(
        'Para crear el acceso directo siga los siguientes pasos:\n\n' +
        '1. Presione •••\n' +
        '2. Presione Compartir ⬆\n' +
        '3. Seleccione "Agregar a inicio"\n' +
        '4. Desmarca la opción "Abrir con app web"\n' +
        '5. Presione en Agregar'
      );
      return;
    }

    if (this.esSafari) {
      alert(
        'Para crear el acceso directo siga los siguientes pasos:\n\n' +
        '1. Menú Archivo\n' +
        '2. Agregar al Dock'
      );
      return;
    }

    if (this.esAndroid) {
      alert(
        'Para crear el acceso directo siga los siguientes pasos:\n\n' +
        '1. Presione ⋮\n' +
        '2. Seleccione "Agregar a la pantalla principal"'
      );
      return;
    }

    alert(
      'Para crear el acceso directo siga los siguientes pasos (Preferencia: Google Chrome):\n\n' +
      '1. Presione ⋮\n' +
      '2. Seleccionar la opción "Transmitir, guardar y compartir"\n' +
      '3. Seleccione la opción "Instalar página como app"'
    );
  }
}
